import { MenuRegistrationPayload } from 'api/menuApi';
import { MenuType, MENU_TYPES } from 'types/menu';

/**
 * メニューカテゴリー新規作成フォーム
 */
export type MenuRegistrationFormFields = {
  /** メニューID */
  id: string;
  /** メニュー名 */
  name: string;
  /** 公開範囲 */
  type: MenuType;
  /** メニュー説明 */
  description: string;
  /** クローラー */
  targetCrawlers: string[];
  /** 並び順 */
  displayOrder: number;
};

export const createMenuRegistrationFormFields = ({
  id = '',
  name = '',
  type = MENU_TYPES.GENERAL,
  description = '',
  targetCrawlers = [],
  displayOrder = 0,
}: Partial<MenuRegistrationFormFields>): MenuRegistrationFormFields => ({
  id,
  name,
  type,
  description,
  targetCrawlers,
  displayOrder,
});

export const mapFormFieldsToMenuRegistrationPayload = ({
  id,
  name,
  type,
  description,
  displayOrder,
}: MenuRegistrationFormFields): Omit<
  MenuRegistrationPayload,
  'categoryId'
> => ({
  id: /^\d+$/.test(id) ? parseInt(id, 10) : null,
  name,
  type,
  description,
  displayOrder,
});
